import React from 'react'
import axios from 'axios'

import Button from '../Form/Button'

export default class NovoChamado extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            ficha: {
                user: localStorage.nome,
                data: new Date().toLocaleDateString(),
                tipo: '',
                mensagem: '',
            }
        }
    }

    updateField(event) {
        const ficha = { ...this.state.ficha }
        ficha[event.target.name] = event.target.value
        this.setState({ ficha })
    }

    save(e) {
        e.preventDefault()
        const url = '/api/suporte'
        const ficha = this.state.ficha
        axios.post(url, ficha)
            .then(res => {
                alert('Seu chamdo foi enviado com sucesso, retornaremos o mais breve possível')
                window.location = `/`
            })
            .catch(error => {
                alert(error.response.data)
            })
    }

    render() {
        return (
            <div className="container mx-auto">
                <div className="form-group row pt-3 text-left">
                    <label className="col-3 col-md-2">Usuário:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <input type="text" className="form-control" value={this.state.ficha.user} />
                    </div>
                    <label className="col-3 col-md-2">Tipo:</label>
                    <div className="col-9 col-md-4 mb-3">
                        <select className="custom-select"
                            name="tipo" onChange={e => this.updateField(e)} >
                            <option value=""></option>
                            <option value="Erro no sistema">Erro no sistema</option>
                            <option value="Mudança em Documento">Mudança em Documento</option>
                        </select>
                    </div>
                    <label className="col-12">Texto:</label>
                    <textarea type="textarea" rows="8" className="form-control col-12 mb-5"
                        placeholder="Por favor, informe o número do Processo, TV, etc..."
                        name="mensagem" onChange={e => this.updateField(e)} />
                    <Button onClick={e => this.save(e)} />
                </div>
            </div>
        )
    }
}